import React from 'react';

import './index.css'
import { BsyUtils } from '../../utils/Utils';
import { BsyWidget } from '../BsyWidget';
import BsyTextEditor from '../BsyTextEditor';

export default class BsySelectList extends BsyWidget {

    constructor(props) {
        super({
            baseCls: "fui_checklist",
            hasSelectAll: !0,
            textField: "text",
            valueField: "value",
            async: null,
            asyncResultKey: props.asyncResultKey ? props.asyncResultKey : "items",
            value: [],
            customItem: null,
            items: [{
                value: React.language("field.options", { num: 1 }),
                text: React.language("field.options", { num: 1 })
            }, {
                value: React.language("field.options", { num: 2 }),
                text: React.language("field.options", { num: 2 })
            }, {
                value: React.language("field.options", { num: 3 }),
                text: React.language("field.options", { num: 3 })
            }],
            allowEmptyTextField: !1,
            searchable: !0,
            onStopEdit: null,
            height: 30,
            width: 240,
            limit: 100,
            hasLimit: !1,
            onAfterItemSelect: null,
            onAfterSelectAll: null,
            searchKey: "keyword",

            ...props
        });
        this.state = {
            css: {},
            seaching: false,
            value: this.options.value,
            items: this.options.items,
            isMore: false,
        }
        this.page = 0;
        this.element = React.createRef();
        this.listRef = React.createRef();
    }

    onMoreData = (cb) => {
        this.page++;
        const { async, limit } = this.options;
        this.loadData(this.page * limit, () => {
            cb && cb(this.state.items, this.isMore);
        });
    };

    loadData = (skip, cb) => {
        const { async, hasLimit, limit, authGroupId, popupFormPath, asyncResultKey, textField, valueField } = this.options;
        if (BsyUtils.isObjectEmpty(async)) {
            this.setState({
                items: [],
                seaching: !1,
            }, () => {
                cb && cb()
            })
            return;
        }
        let n = {
            hasLimit: hasLimit,
            skip: skip,
            limit: limit,
            authGroupId: authGroupId,
            popupFormPath: popupFormPath ? [...popupFormPath] : undefined,
            ...async.data,
        };
        if (['combo', 'combocheck'].indexOf(this.options.type) > -1) {
            n.popupFormPath = undefined;
        }
        if (n.hasOwnProperty("hasCurrentUser")) {
            if (BsyUtils.isObjectEmpty(n.filter) || BsyUtils.isObjectEmpty(n.filter.cond))
                n.hasCurrentUser = true;
            else {
                n.hasCurrentUser = false;
            }
        }
        if (!BsyUtils.isObjectEmpty(this.searchValue)) {
            n.keyword = this.searchValue + "";
            if (n.hasOwnProperty("hasCurrentUser")) {
                n.hasCurrentUser = false;
            }
        }
        if (this.options.designAppId) {
            n.designAppId = this.options.designAppId;
            n.designEntryId = this.options.designEntryId;
            n.widgetName = this.options.orgWidgetName || this.options.widgetName;
            n.subformName = this.options.subformName || this.options.subform;
        }
        React.axios(async.url, {
            ...n,
        }).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {
                let dd = [];

                if (res.data[asyncResultKey])
                    this.isMore = res.data[asyncResultKey].length === limit;

                BsyUtils.forEach(res.data[asyncResultKey], (a1, b1) => {



                    if (BsyUtils.isString(b1) || BsyUtils.isNumber(b1)) {
                        dd.push({
                            ...res.data[asyncResultKey][a1],
                            [textField]: b1 + '',
                            [valueField]: b1 + '',
                        })
                    } else {
                        dd.push({
                            ...res.data[asyncResultKey][a1],
                            [textField]: b1[textField],
                            [valueField]: b1[valueField],
                        })
                    }
                })

                let ddc = [];
                if (skip > 0) {
                    if (this.state.items) ddc = [...this.state.items];
                }
                ddc = ddc.concat(dd);
                this.setState({
                    items: ddc,
                    isMore: this.isMore,
                    seaching: !1,
                }, () => {
                    cb && cb()
                })
            })

        }).catch(res => {
            console.error(res);

        })

    }

    componentDidMount() {
        super.componentDidMount();
        this.loadData(0);
    }

    selectItem = (val) => {
        return () => {
            const { items } = this.state
            const { valueField } = this.options;

            // const newitems = items.map((v) => {
            //     val === v[valueField] ? v.selected = true : v.selected = false
            //     return v
            // })
            this.setState({ value: val }, () => {

                if (this.props.onStopEdit) {
                    this.props.onStopEdit(val)
                }
            })
        }
    }
    getValue = () => {
        return this.state.value
    }



    seachItems = (val) => {
        let that = this;
        if (this.searchValue !== val) {
            this.searchinterval && clearTimeout(this.searchinterval)
            this.searchValue = val;
            this.setState({
                seaching: true
            })
            this.searchinterval = setTimeout(function () {
                that.seachCallBack();
            }, 500)
        }
    }

    seachCallBack = () => {
        const { items } = this.state
        const { valueField, textField } = this.options;
        if (!this.searchValue) {
            this.setState({
                items: this.bakAllitems,
                seaching: false,
            }, () => {
                this.bakAllitems = null;
            })
        } else {
            if (BsyUtils.isObjectEmpty(this.bakAllitems)) {
                this.bakAllitems = [...items]
            }
            this.loadData(0)
        }

    }

    onScroll = (e) => {
        const { isMore } = this.state;

        if (isMore) {
            if (this.listRef && this.listRef.current) {
                if (
                    this.listRef.current.offsetHeight <=
                    e.target.scrollTop + e.target.offsetHeight + 10
                ) {
                    this.setState(
                        {
                            isMore: false,
                        },
                        () => {

                            this.onMoreData((items, isMore) => {
                                this.setState({
                                    items: [...items],
                                    isMore: isMore,
                                });
                            });

                            console.log("操作更多");
                        }
                    );
                }
            }
        }
    };

    renderSelectList = () => {
        const { allowBlank, searchable } = this.options
        const { css, items, seaching, value, isMore } = this.state
        const { valueField, textField } = this.options;
        return <>
            {
                searchable ? <div className='bsy-combo-search' >

                    <BsyTextEditor
                        onAfterEdit={this.seachItems}
                        waterMark={React.language("search")}
                        width={"100%"}
                        value={this.searchValue}
                    ></BsyTextEditor>

                </div> : <></>
            }
            <div style={css} className="selectList"
                onScroll={this.onScroll}
            >

                <div style={{
                    overflow: 'hidden',
                }} ref={this.listRef}>


                    {
                        seaching && <div className='loading-text'>
                            <span>{React.language('searching')}</span>
                        </div>
                    }

                    {

                        !seaching && items && items.map((val) => {
                            let selected = false;
                            if (!value) {
                                selected = val.selected ? val.selected : false;
                            } else {
                                selected = val[valueField] == value
                            }

                            if (this.props.onCustomItem) {
                                return <div key={val[valueField]}
                                    title={val[textField]}
                                    onClick={this.selectItem(val[valueField])} className={selected ? "item select" : "item"}>
                                    <i className='icon-blank'></i>
                                    {
                                        this.props.onCustomItem(val)
                                    }
                                </div>
                            }

                            return <div key={val[valueField]}
                                title={val[textField]}
                                onClick={this.selectItem(val[valueField])} className={selected ? "item select" : "item"}>
                                <i className='icon-blank'></i>
                                <span> {
                                    val[textField]
                                }</span>

                            </div>
                        })

                    }
                    {!seaching && isMore ? (
                        <div className="loading">{React.language("loading")}</div>
                    ) : (
                        ""
                    )}

                </div>

            </div>

        </>
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.value !== this.state.value) {
            this.setState({
                value: nextProps.value,
            })
        }

    }

    render() {

        const { items, value } = this.state
        const { valueField, textField } = this.options;
        let text = [];
        items && items.map((val) => {
            if ((val.selected || val[valueField] === value))
                val[valueField] && text.push(val[textField])
        })
        return (
            <div className={"BsySelectList "} ref={this.element} >
                {
                    this.renderSelectList()
                }
            </div>
        );
    }
}
